export const mutations = {
  setDestinations(state, destinations) {
    state.destinations = destinations;
  },
  setProspectiveDestinations(state, prospectiveDestinations) {
    state.prospectiveDestinations = prospectiveDestinations;
  },
};
